import { Box, Button, HStack, Icon, Link, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export * from './base.styled';

export const DetailsBox = Box.withConfig({
  backgroundColor: Styles.color.cardBackground,
  borderRadius: Styles.borderRadius,
  style: {
    shadowColor: Styles.shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },
  paddingY: '$5',
  paddingX: '$6',
  _text: {
    variant: 'copyOne',
    fontSize: 'md',
  },
});

export const TextStyled = Text.withConfig({});

export const FieldContainer = Box.withConfig({
  marginBottom: '$4',
  accessible: true,
});

export const HeadingContainer = HStack.withConfig({
  justifyContent: 'space-between',
  marginBottom: '$6',
  marginTop: '$5',
});

export const PickupTimeHeadingContainer = HeadingContainer.withConfig({
  alignItems: 'center',
  marginBottom: '$0',
  marginTop: '$0',
  margin: {
    base: '$0',
  },
  marginX: {
    base: '$4',
  },
  focusable: true,
});

export const PickupDetailsAddress = Box.withConfig({
  paddingY: '$5',
  paddingX: '$6',
  accessible: true,
});

export const ChangeLink = Link.withConfig({
  color: Styles.color.black,
  fontSize: 'md',
  fontWeight: '400',
  paddingX: '$0',
  marginLeft: 'auto',
  _web: {
    cursor: 'pointer',
  },
});

export const EtaContainer = Box.withConfig({
  width: { base: '135px', md: '142px' },
});

export const PickupDetailsBox = Box.withConfig({
  borderRadius: Styles.borderRadius,
});

export const DetailsWrapper = HStack.withConfig({
  backgroundColor: primitive.$white,
  borderRadius: 10,
  borderBottomRadius: 0,
  padding: '$4',
  flex: 1,
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const IconStyled = Icon.withConfig({
  size: 5,
  marginRight: '$1',
});

export const ServiceModesFooter = HStack.withConfig({
  justifyContent: 'flex-end',
  paddingX: '$4',
  paddingY: '$1',
  borderBottomRadius: 10,
  backgroundColor: primitive.$blackOpacity4,
});

export const ChangeServiceModeButton = Button.withConfig<{ isDesktopWeb: boolean }>(props => ({
  minWidth: props.isDesktopWeb ? '$18' : '$16',
  padding: '$2',
  paddingLeft: props.isDesktopWeb ? '$4' : '$3',
  paddingRight: props.isDesktopWeb ? '$4' : '$3',
}));
